let modelViewerImportPromise = null;

const VIEWER_ASSET_ORIGIN = "https://viewer.10k.science";

export const resolveModelViewerAssetUrl = (
  assetUrl,
  {
    currentOrigin = typeof window === "undefined" ? "" : window.location.origin,
    isDevelopment = process.env.NODE_ENV === "development",
  } = {},
) => {
  if (!assetUrl || !currentOrigin || !isDevelopment) {
    return assetUrl;
  }

  try {
    const currentUrl = new URL(currentOrigin);
    const parsedAssetUrl = new URL(assetUrl, currentUrl);

    if (
      parsedAssetUrl.origin === VIEWER_ASSET_ORIGIN &&
      parsedAssetUrl.origin !== currentUrl.origin
    ) {
      return `${parsedAssetUrl.pathname}${parsedAssetUrl.search}${parsedAssetUrl.hash}`;
    }
  } catch {
    return assetUrl;
  }

  return assetUrl;
};

export const loadModelViewer = () => {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }

  if (window.customElements?.get("model-viewer")) {
    return Promise.resolve();
  }

  if (!modelViewerImportPromise) {
    modelViewerImportPromise = import("@google/model-viewer").catch((error) => {
      modelViewerImportPromise = null;
      throw error;
    });
  }

  return modelViewerImportPromise;
};
